import { Box, Button, Chip, CircularProgress, Sheet, Stack, Tab, TabList, Tabs, Typography } from "@mui/joy";
import { Outlet, useLocation, useNavigate } from "react-router";
import { CssVarsProvider } from "@mui/joy/styles";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import AdminPanelSettingsRoundedIcon from "@mui/icons-material/AdminPanelSettingsRounded";

import { useAdmin } from "../../AdminContext";
import { theme } from "../../App";

const ROLE_LABELS = {
  superadmin: "Суперадмин",
  moderator: "Модератор",
  finance: "Финансы",
  support: "Поддержка",
};

export default function AdminLayout() {
  const { authStatus, admin, logout } = useAdmin();
  const navigate = useNavigate();
  const location = useLocation();

  if (authStatus === "idle" || authStatus === "verifying") {
    return (
      <CssVarsProvider theme={theme}>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", flexDirection: "column", gap: 2 }}>
          <CircularProgress />
          <Typography level="body-sm" color="neutral">Проверка доступа…</Typography>
        </Box>
      </CssVarsProvider>
    );
  }

  if (authStatus === "unauthed") {
    return (
      <CssVarsProvider theme={theme}>
        <Stack alignItems="center" justifyContent="center" sx={{ height: "100vh" }}>
          <Typography level="body-md" color="neutral">Перенаправление…</Typography>
        </Stack>
      </CssVarsProvider>
    );
  }

  // Активная вкладка верхнего уровня
  const P = location.pathname;
  const tabValue =
    P.startsWith("/admin/ads") ? "ads" :
    P.startsWith("/admin/places") ? "places" :
    P.startsWith("/admin/verifications") ? "verifications" :
    P.startsWith("/admin/antifraud") ? "antifraud" :
    P.startsWith("/admin/date-treats") ? "dateTreats" :
    P.startsWith("/admin/traits") ? "traits" :
    P.startsWith("/admin/profiles") ? "profiles" :
    P.startsWith("/admin/partners") ? "partners" :
    P.startsWith("/admin/payouts") ? "payouts" :
    P.startsWith("/admin/referrals") ? "referrals" :
    P.startsWith("/admin/settings") ? "settings" :
    "quizzes";

  const TAB_ROUTES = {
    quizzes: "/admin",
    profiles: "/admin/profiles",
    traits: "/admin/traits",
    dateTreats: "/admin/date-treats",
    places: "/admin/places",
    verifications: "/admin/verifications",
    antifraud: "/admin/antifraud",
    partners: "/admin/partners",
    payouts: "/admin/payouts",
    referrals: "/admin/referrals",
    settings: "/admin/settings",
    ads: "/admin/ads",
  };

  return (
    <CssVarsProvider theme={theme}>
      <Box sx={{ minHeight: "100vh", backgroundColor: "background.body" }}>
        <Sheet
          variant="soft"
          sx={{
            position: "sticky", top: 0, zIndex: 100,
            px: { xs: 2, md: 4 }, py: 1.5,
            display: "flex", alignItems: "center", justifyContent: "space-between",
            borderBottom: "1px solid", borderColor: "divider",
          }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <AdminPanelSettingsRoundedIcon color="primary" />
            <Typography level="title-lg">Админ-панель</Typography>
          </Stack>
          <Stack direction="row" spacing={1.5} alignItems="center">
            {admin && (
              <Box sx={{ textAlign: "right", display: { xs: "none", sm: "block" } }}>
                <Typography level="body-sm" sx={{ fontWeight: 700 }}>{admin.full_name || admin.email}</Typography>
                <Chip size="sm" variant="soft" color="primary">{ROLE_LABELS[admin.role] || admin.role}</Chip>
              </Box>
            )}
            <Button size="sm" variant="outlined" color="neutral" startDecorator={<LogoutRoundedIcon />} onClick={logout}>
              Выйти
            </Button>
          </Stack>
        </Sheet>

        <Box sx={{ px: { xs: 2, md: 4 }, pt: 2 }}>
          <Tabs
            value={tabValue}
            onChange={(_, v) => navigate(TAB_ROUTES[v] || "/admin")}
            sx={{ backgroundColor: "transparent", mb: 2 }}
          >
            <TabList>
              <Tab value="quizzes">Тесты</Tab>
              <Tab value="profiles">Анкеты</Tab>
              <Tab value="traits">Параметры</Tab>
              <Tab value="dateTreats">Свидания</Tab>
              <Tab value="places">Места</Tab>
              <Tab value="verifications">Верификация</Tab>
              <Tab value="antifraud">Антифрод</Tab>
              <Tab value="partners">Партнёры</Tab>
              <Tab value="payouts">Выплаты</Tab>
              <Tab value="referrals">Рефералы</Tab>
              <Tab value="settings">Настройки</Tab>
              <Tab value="ads">Реклама</Tab>
            </TabList>
          </Tabs>

          <Box sx={{ pb: 6 }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </CssVarsProvider>
  );
}